module.exports = __webpack_public_path__ + "img/search-favorite.72ee5bc3.svg";